module.exports = __webpack_public_path__ + "static/media/sign-language.e60af30c.svg";